import { render, staticRenderFns } from "./messageChart.vue?vue&type=template&id=47a9df6d&"
import script from "./messageChart.vue?vue&type=script&lang=js&"
export * from "./messageChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports